import { getTenant as retrieveTenant, saveTenant as persistTenant } from "api/tenant";

export const TENANT_GET = "TENANT_GET";
export const TENANT_SAVE = "TENANT_SAVE";

export const getTenant = (dealID) => (dispatch) =>
  dispatch({
    type: TENANT_GET,
    payload: retrieveTenant(dealID),
  });

export const saveTenant = (dealID, tenant) => (dispatch) =>
  dispatch({
    type: TENANT_SAVE,
    payload: persistTenant(dealID, tenant),
  });
